import { useEffect, useState } from 'react';
import { api, ApiError } from '../api';

/**
 * "Add to Wallet" actions. Each button only appears once the server confirms
 * that platform is configured, so an unconfigured build shows nothing rather
 * than a button that fails on tap.
 */
export function WalletButtons() {
  const [available, setAvailable] = useState<{ apple: boolean; google: boolean } | null>(null);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    api
      .walletAvailability()
      .then(setAvailable)
      .catch(() => setAvailable(null));
  }, []);

  if (!available || (!available.apple && !available.google)) return null;

  const addToGoogle = async () => {
    setBusy(true);
    setError(null);
    try {
      const { url } = await api.googleWalletUrl();
      window.location.href = url;
    } catch (err) {
      setError(err instanceof ApiError ? err.message : 'No pudimos generar el pase');
      setBusy(false);
    }
  };

  return (
    <div className="wallet-actions">
      <div className="eyebrow eyebrow--tight" style={{ marginBottom: 10 }}>
        Llevá tu cartilla
      </div>

      {error && (
        <div className="notice notice--error" style={{ marginBottom: 10 }} role="alert">
          {error}
        </div>
      )}

      <div className="wallet-buttons">
        {available.apple && (
          // A plain link, not fetch: iOS hands .pkpass straight to Wallet.
          <a className="wallet-btn" href="/api/me/wallet/apple">
            <svg width="20" height="20" viewBox="0 0 24 24" aria-hidden="true">
              <path
                fill="currentColor"
                d="M16.4 12.7c0-2.1 1.7-3.1 1.8-3.2-1-1.4-2.5-1.6-3-1.7-1.3-.1-2.5.8-3.2.8-.7 0-1.6-.7-2.7-.7-1.4 0-2.7.8-3.4 2.1-1.4 2.5-.4 6.2 1 8.2.7 1 1.5 2.1 2.6 2.1 1 0 1.4-.7 2.7-.7 1.2 0 1.6.7 2.7.6 1.1 0 1.8-1 2.5-2 .8-1.2 1.1-2.3 1.1-2.3s-2.1-.8-2.1-3.2zM14.3 6.3c.6-.7 1-1.7.9-2.7-.9 0-1.9.6-2.5 1.3-.5.6-1 1.6-.9 2.6 1 .1 2-.5 2.5-1.2z"
              />
            </svg>
            Agregar a Apple Wallet
          </a>
        )}

        {available.google && (
          <button className="wallet-btn" onClick={() => void addToGoogle()} disabled={busy}>
            <svg width="20" height="20" viewBox="0 0 24 24" aria-hidden="true">
              <path
                fill="currentColor"
                d="M20 7H4a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2zm0 6h-5a1 1 0 0 1 0-2h5v2zM5.5 5h11a1 1 0 0 0 0-2h-11a1 1 0 0 0 0 2z"
              />
            </svg>
            {busy ? 'Generando…' : 'Agregar a Google Wallet'}
          </button>
        )}
      </div>

      <div className="wallet-note">
        El pase muestra tus sellos y se actualiza solo después de cada compra.
      </div>
    </div>
  );
}
